export default "/assets/images/smoky-gray.jpg?9e1f1b3f3929a7cae58864b6503e2d1a";